export default "__VITE_ASSET__CBwgmKkD__"